module.exports = __webpack_public_path__ + "static/media/Avatar8b.b80a6c0c.png";